import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import PersonalProtectiveEquipmentTransferForm from '../Forms/PersonalProtectiveEquipmentTransferForm';

const PersonalProtectiveEquipmentTransferModal = ({
    dataPersonalProtectiveEquipment,
    isOpen,
    isEdit,
    handleToggleModal,
    activeTab,
    toggleTab,
    establishmentId
}) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={handleToggleModal}
            size='xl'
            className='border-0'
            modalClassName='modal fade zoomIn'
            backdrop={'static'}
            centered={true}
        >
            <ModalHeader toggle={handleToggleModal}>
                {isEdit ? 'Editar Transferencia de' : 'Transferir'} Equipamiento de Protección Personal a Bodega
            </ModalHeader>

            <div className='modal-content border-0 mt-3'>
                <Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
                    <NavItem>
                        <NavLink href='#' className={classnames({ active: activeTab === '1' })} onClick={() => { toggleTab('1'); }}>
                            Información General
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink href='#' className={classnames({ active: activeTab === '2' })} onClick={() => { toggleTab('2'); }}>
                            Items a Transferir
                        </NavLink>
                    </NavItem>
                </Nav>
            </div>

            <PersonalProtectiveEquipmentTransferForm
                dataPersonalProtectiveEquipment={dataPersonalProtectiveEquipment}
                isOpen={isOpen}
                isEdit={isEdit}
                handleToggleModal={handleToggleModal}
                activeTab={activeTab}
                toggleTab={toggleTab}
                establishmentId={establishmentId}
            />
        </Modal>
    );
};

export default PersonalProtectiveEquipmentTransferModal;
